import https from "./https";
import store from "@/store";

const partnerMarketingEvent = {
  getPartnerMarketingEvents(params) {
    const organization = store.state.general.organization;
    return https.get(`admin/organizations/${organization.id}/partner-marketing-events`, { params });
  },
  getPartnerMarketingEvent(id) {
    const organization = store.state.general.organization;
    return https.get(`admin/organizations/${organization.id}/partner-marketing-events/${id}`);
  },
  createPartnerMarketingEvent(params) {
    const organization = store.state.general.organization;
    return https.post(`admin/organizations/${organization.id}/partner-marketing-events`, params);
  },
  updatePartnerMarketingEvent(id, params) {
    const organization = store.state.general.organization;
    return https.put(`admin/organizations/${organization.id}/partner-marketing-events/${id}`, params);
  },
  deletePartnerMarketingEvent(id) {
    const organization = store.state.general.organization;
    return https.delete(`admin/organizations/${organization.id}/partner-marketing-events/${id}`);
  },
  uploadImageByBase64(data) {
    const organization = store.state.general.organization;
    return https.post(`admin/organizations/${organization.id}/partner-marketing-events/images/upload-by-base64`, data);
  },
  removeImageUrl(id) {
    const organization = store.state.general.organization;
    return https.delete(`admin/organizations/${organization.id}/partner-marketing-events/${id}/remove-image-url`);
  },
  getMaxSort() {
    const organization = store.state.general.organization;
    return https.get(`admin/organizations/${organization.id}/partner-marketing-events/max-sort`);
  }
};

export default partnerMarketingEvent;
